module.exports = __webpack_public_path__ + "img/lab-outline.633134e3.svg";